export default __webpack_public_path__ + "static/media/pen.baa03b4d.svg";